import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OfferBanner() {
  return <section className="py-16 md:py-20 px-6 bg-deep" data-id="element-101">
      <div className="max-w-5xl mx-auto text-center" data-id="element-102">
        <FadeIn data-id="element-103">
          <div className="relative rounded-xl overflow-hidden mb-10 shadow-2xl border border-white/10" data-id="element-104">
            <video src="https://cdn.magicpatterns.com/uploads/19af3uPc7YmUbZeBy6NpzQ/video landing.mp4" autoPlay loop muted playsInline className="w-full h-auto object-cover" data-id="element-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-deep/80 via-transparent to-transparent flex items-end justify-center pb-8" data-id="element-106">
              <p className="text-amber font-semibold tracking-widest uppercase text-sm md:text-base drop-shadow-md animate-pulse" data-id="element-107">
                Restoring the Natural Rhythm of Vitality
              </p>
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight" data-id="element-108">
            Ready to Neutralize Mitochondrial Decay?
          </h2>
          <p className="text-lg md:text-xl text-amber font-semibold mt-4 tracking-wide" data-id="element-109">
            Here is everything you're getting today for 85% OFF:
          </p>
        </FadeIn>
      </div>
    </section>;
}